import { render, staticRenderFns } from "./QuickChatReplyPopup.vue?vue&type=template&id=1ab63e66&scoped=true&"
import script from "./QuickChatReplyPopup.vue?vue&type=script&lang=ts&"
export * from "./QuickChatReplyPopup.vue?vue&type=script&lang=ts&"
import style0 from "./QuickChatReplyPopup.vue?vue&type=style&index=0&id=1ab63e66&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab63e66",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VList,VListItem,VListItemContent,VTextField})
